import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { List, ListItem, useTheme } from "@mui/material";

//recoil
import { useSetRecoilState } from "recoil";
import { atomDocumentType } from "../../Recoil";

//components
import { CustomerSelector } from "./StyleComponents";

export default function NavBarSecondaryMenu(props) {
  const { t } = useTranslation();
  const theme = useTheme();
  const location = useLocation();

  const setDocumentType = useSetRecoilState(atomDocumentType);

  const ListItemStyle = {
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
    fontSize: "0.93em",
    textTransform: "uppercase",
    "&:not(.active)": {
      "&:hover": {
        color: theme.palette.primary.main,
      },
    },
  };

  return (
    <List
      component="nav"
      aria-labelledby="main navigation"
      className={props.propsClass}
    >
      {location.pathname.startsWith("/Receive") ? (
        <React.Fragment>
          <ListItem
            to={"/Receive/Invoice"}
            component={NavLink}
            sx={ListItemStyle}
            style={({ isActive }) => ({
              backgroundColor: isActive ? theme.palette.primary.main : null,
            })}
            button
            onClick={() => setDocumentType("Invoice")}
          >
            {t("validationService.Invoices")}
          </ListItem>

          <ListItem
            to={"/Receive/ApplicationResponse"}
            component={NavLink}
            sx={ListItemStyle}
            style={({ isActive }) => ({
              backgroundColor: isActive ? theme.palette.primary.main : null,
            })}
            button
            onClick={() => setDocumentType("ApplicationResponse")}
          >
            {t("validationService.ApplicationResponses")}
          </ListItem>

          <ListItem
            to={"/Receive/Order"}
            component={NavLink}
            sx={ListItemStyle}
            style={({ isActive }) => ({
              backgroundColor: isActive ? theme.palette.primary.main : null,
            })}
            button
            onClick={() => setDocumentType("Order")}
          >
            {t("validationService.Orders")}
          </ListItem>

          <ListItem
            to={"/Receive/OrderResponse"}
            component={NavLink}
            sx={ListItemStyle}
            style={({ isActive }) => ({
              backgroundColor: isActive ? theme.palette.primary.main : null,
            })}
            button
            onClick={() => setDocumentType("OrderResponse")}
          >
            {t("validationService.OrderResponses")}
          </ListItem>
        </React.Fragment>
      ) : null}

      {location.pathname.startsWith("/Send") ? (
        <React.Fragment>
          <ListItem
            to={"/Send/Invoice"}
            component={NavLink}
            sx={ListItemStyle}
            style={({ isActive }) => ({
              backgroundColor: isActive ? theme.palette.primary.main : null,
            })}
            button
            onClick={() => setDocumentType("Invoice")}
          >
            {t("validationService.Invoices")}
          </ListItem>

          <ListItem
            to={"/Send/ApplicationResponse"}
            component={NavLink}
            sx={ListItemStyle}
            style={({ isActive }) => ({
              backgroundColor: isActive ? theme.palette.primary.main : null,
            })}
            button
            onClick={() => setDocumentType("ApplicationResponse")}
          >
            {t("validationService.ApplicationResponses")}
          </ListItem>

          <ListItem
            to={"/Send/Order"}
            component={NavLink}
            sx={ListItemStyle}
            style={({ isActive }) => ({
              backgroundColor: isActive ? theme.palette.primary.main : null,
            })}
            button
            onClick={() => setDocumentType("Order")}
          >
            {t("validationService.Orders")}
          </ListItem>

          <ListItem
            to={"/Send/OrderResponse"}
            component={NavLink}
            sx={ListItemStyle}
            style={({ isActive }) => ({
              backgroundColor: isActive ? theme.palette.primary.main : null,
            })}
            button
            onClick={() => setDocumentType("OrderResponse")}
          >
            {t("validationService.OrderResponses")}
          </ListItem>

          <ListItem
            to={"/Send/EReporting"}
            component={NavLink}
            sx={ListItemStyle}
            style={({ isActive }) => ({
              backgroundColor: isActive ? theme.palette.primary.main : null,
            })}
            button
            onClick={() => setDocumentType("EReporting")}
          >
            {t("validationService.EReporting")}
          </ListItem>
        </React.Fragment>
      ) : null}

      <div
        style={{
          position: "absolute",
          right: "10px",
        }}
      >
        <CustomerSelector />
      </div>
    </List>
  );
}
